module.exports = __webpack_public_path__ + "static/media/blog-10.0d55ca3c.svg";